import React, { useState } from "react";
import { RiFullscreenLine, RiFullscreenExitLine } from "react-icons/ri";

const ZoomScreen = ({ id, cardSizeClass, setZoomActive = () => {} }) => {
  const [isActive, setIsActive] = useState(false);
  const zoomOutScreen = () => {
    // console.log("hellllllllllllllllooooooo");
    const element = document.getElementById(id);
    element.className = !isActive
      ? "activeZoomScreen"
      : cardSizeClass
      ? cardSizeClass
      : "mb-4 pb-2 col-md-6";
    setIsActive(!isActive);
    setZoomActive(!isActive);
  };
  return (
    <>
      <span data-testid="ZoomScreen" className="ZoomIcon" onClick={() => zoomOutScreen()}>
        {!isActive ? <RiFullscreenLine /> : <RiFullscreenExitLine />}
      </span>
    </>
  );
};

export default ZoomScreen;
